import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cache = new Map<string, { data: HttpResponse<any>, expiry: number }>();
  // Tiempo de vida del caché en milisegundos (ej. 1 minuto = 60000ms)
  private readonly CACHE_DURATION_MS = 60000;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Solo cacheamos peticiones GET
    if (request.method !== 'GET') {
      return next.handle(request);
    }

    // No cachear si la url contiene 'nocache' o parámetros similares que el backend usa para forzar refresco
    if (request.urlWithParams.includes('nocache') || request.headers.has('reset-cache')) {
      return next.handle(request);
    }

    const cachedResponse = this.cache.get(request.urlWithParams);

    // Si tenemos la respuesta en caché y no ha expirado
    if (cachedResponse && Date.now() < cachedResponse.expiry) {
      return of(cachedResponse.data);
    }

    // Si no está en caché o expiró, hacemos la petición y la guardamos
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.cache.set(request.urlWithParams, {
            data: event,
            expiry: Date.now() + this.CACHE_DURATION_MS
          });
        }
      })
    );
  }
}
